let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hoTme")).then(() => parcelRequire('jLkf4'));